import React from 'react';
import { FileText } from 'lucide-react';

const Navbar = ({ onNewInvoice, currentView, setCurrentView }) => {
  return (
    <nav className="bg-gradient-to-r from-indigo-900 via-purple-900 to-pink-900 text-white shadow-2xl">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-white/10 rounded-lg backdrop-blur-sm">
              <FileText className="h-8 w-8 text-white" />
            </div>
            <span className="text-xl font-bold bg-gradient-to-r from-white to-indigo-200 bg-clip-text text-transparent">
              Invoice Generator Pro
            </span>
          </div>
          <div className="hidden md:flex items-center space-x-6">
            <button 
              onClick={() => setCurrentView('create')}
              className={`px-6 py-2 rounded-lg transition-all duration-200 ${
                currentView === 'create' 
                  ? 'bg-white/20 backdrop-blur-sm shadow-lg' 
                  : 'hover:bg-white/10'
              }`}
            >
              Create Invoice
            </button>
            <button 
              onClick={() => setCurrentView('saved')}
              className={`px-6 py-2 rounded-lg transition-all duration-200 ${
                currentView === 'saved' 
                  ? 'bg-white/20 backdrop-blur-sm shadow-lg' 
                  : 'hover:bg-white/10'
              }`}
            >
              Saved Invoices
            </button>
          </div>
          <div className="flex items-center space-x-4">
            <button
              onClick={onNewInvoice}
              className="bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white px-6 py-2 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              New Invoice
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;